import { LogLevel } from '../../log/Interfaces';
import { Level } from '../../log/LoggerConstants';

export interface FailedRequest {
  status: number;
  statusText: string;
  level?: LogLevel<Level>;
}

const isaFailedRequest = (r: unknown): r is FailedRequest => {
  const { status, statusText } = (r || {}) as FailedRequest;
  return typeof status !== 'undefined' && typeof statusText !== 'undefined';
};

export default isaFailedRequest;
